import React from 'react';
import { Image } from 'react-bootstrap';
import Button from '../Shared/Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/Shared/AcceptTermsConditionsModal.css';
import RespModal from '../Shared/RespModal';
import '../../css/Shared/SessionExpire.css';
import alert from '../../Assets/TruckVisits/Assets-Desktop/alert.svg';

function SessionExpire(props) {
    return(
        <RespModal hasOpen={props.hasOpen}  >
        <div className="acceptTCmodalsize" >
            <Image src={alert} /><br /><br />
            <div id="acceptTCmodalcontainsuccess">
               {props.children}
            </div>
            <div class="acceptTCcancelresploginbuttonouter">
            <Button
                id="acceptTCcancelresploginbuttonEnd"
                type="button"
                class="btn btn-dark"
                onClick={props.onCloseModal}
            >Continue
        </Button>
        <Button
                id="acceptTCcancelresploginbuttonCon"
                type="button"
                class="btn btn-dark"
                onClick={props.onYesModal}
            >Log Out
        </Button>
            </div>
        </div>
    </RespModal>
    );
}
export default SessionExpire;